import { IconProps } from "./types";
import React from "react";

export const ResizeIcon = ({
  className,
  fill = "currentColor",
  width = 14,
  height = 14,
  style = {},
}: IconProps): React.ReactElement => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
  >
    <path
      d="M4.875 10.252L2.25 10.252L2.25 7.62695M2.48977 10.0129L9.37547 3.12648M7.125 2.75195L9.75 2.75195L9.75 5.37695"
      stroke={fill}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);
